export default __webpack_public_path__ + "static/media/36I-102705_-15691_0.88348070.jpg";